/// <amd-module name="VC/Markdown/Plugins/PathUtilities/GitVersionControlPathUtility" />

/*
 * This file was ported from the legacy webplatform
 * Logic that is not needed for markdown token transformation was not ported over.
 * Logic has only been changed where necessary to interact in the modern web platform.
 * There is no intention to change any factorings or style otherwise.
 */
import * as VersionControlPath from "VC/Markdown/Plugins/PathUtilities/VersionControlPath";
import * as VersionControlPathUrl from "VC/Markdown/Plugins/PathUtilities/VersionControlPathUrl";

export class GitVersionControlPathUtility {

    public static combine(path1?: string, path2?: string): string {

        if (!path1) {
            return path2 !== undefined ? path2 : "";
        }

        if (!path2) {
            return path1 !== undefined ? path1 : "";
        }

        let basePath = path1;
        let path = path2;

        if (path2.charAt(0) === "/") {
            basePath = "/";
            path = path2.substr(1);
        }

        let directory: string = VersionControlPath.getDirectory(basePath);
        path = VersionControlPathUrl.resolveRelativePath(path, directory);
        return path;
    }
}
